<template>
  <div class="repeater">
    <div v-for="(row, index) in rows"
         class="d-flex justify-content-between"
         :key="row.id">
      <div class="flex-grow-1 mr-4">
        <fields-comp :fields="fields"
                     :label-block-with="12"
                     :prefill-params="row"
                     :editing="editing"
                     :mb="mb"
                     :inline="inline"
                     :show-submit-button="showSubmitButton"
                     :form-columns="formColumns"
                     :clear-fields="clearFields"/>
      </div>
      <div>
        <b-button
            @click="removeRow(index)"
            variant="outline-primary"
            size="sm"
            :style="{height: '40px', width: '40px', 'margin-top': fields.length && fields[0].label ? '29px' : '0'}">
          <i class="fas fa-trash fa-lg"></i>
        </b-button>
      </div>
    </div>
    <div class="d-flex justify-content-end">
      <b-button @click="addRow()"
                variant="outline-primary"
                size="sm"
                style="height: 40px; width: 40px;">
        <i class="fas fa-plus fa-lg"></i>
      </b-button>
    </div>
  </div>
</template>

<script>
  export default {
    name: "formFieldRepeater",
    components: {
      'fields-comp': () => import('../../global/formFields.vue')
    },
    data() {
      return {
        repeaterRows: [],
        repeaterPrefilledParams: {},
        uniqueIndex: 1
      }
    },
    props: {
      paramsKey: {
        type: String,
        required: true
      },
      fields: {
        type: Array,
        require: true
      },
      labelBlockWith: {
        type: Number,
        default: 3
      },
      prefillParams: {
        type: Object
      },
      editing: {
        type: Boolean,
        default: false
      },
      mb: {
        type: Number,
        default: 4
      },
      inline: {
        type: Boolean,
        default: false
      },
      showSubmitButton: {
        type: Boolean,
        default: false
      },
      formColumns: {
        type: Number,
        default: 12
      },
      emitSubmitForm: {
        type: Boolean,
        default: false
      },
      clearFields: {
        type: Boolean,
        default: false
      },
    },
    computed: {
      rows() {
        return this.prefillParams[this.paramsKey];
      }
    },
    methods: {
      addRow() {
        this.uniqueIndex += 1;
        this.rows.push({id: 'new-row-id-' + this.uniqueIndex});
      },
      removeRow(index) {
        this.rows.splice(index, 1);
      }
    }
  }
</script>